import { render } from "./financeorderPage.vue?vue&type=template&id=3988cd08"
import script from "./financeorderPage.vue?vue&type=script&lang=js"
export * from "./financeorderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__